import * as yup from 'yup';
import { TFunction } from 'i18next';
import { ITreeItem } from '~/utils/interface/common';
import { IPackageProduct } from '~/utils/interface/package';

export const treeItemPackageProductSchema = (t: TFunction): yup.ObjectSchema<ITreeItem<IPackageProduct>> =>
  yup.object().shape({
    id: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    level: yup.number().required(t('common_validate_field_required', { ns: 'common/base' })),
    screenId: yup.string().optional(),
    type: yup.string().optional(),
    parentId: yup.string().optional(),
    order: yup.number().optional(),
    canHaveChildren: yup.boolean().optional(),
    addOn: yup.boolean().optional(),
    data: yup
      .object()
      .shape({
        quantity: yup.number().required(t('common_validate_field_required', { ns: 'common/base' })),
      })
      .required(t('common_validate_field_required', { ns: 'common/base' })),
    children: yup.lazy(() => yup.array().of(treeItemPackageProductSchema(t))).optional(),
    parent: treeItemParentSchema.optional(),
  });

const treeItemParentSchema = yup.object({
  id: yup.string().required(),
  level: yup.number().required(),
  parentId: yup.string().optional(),
  type: yup.string().optional(),
});
